import { Component, OnInit } from '@angular/core';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'ngx-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.scss'],
})
export class InformesComponent implements OnInit {
  resultadoRequest:any;
  parametrosUrl: any;
  listActividades:any;
  fechaInicio:Date;
  fechaFin:Date;
  act:any = '0';
  prueba:boolean = true;
  placeholderAct = '---';
  datepip:any;
  constructor(private _http : PeticionesHttpBackEndService,private utilidades: UtilidadesService, private _route: ActivatedRoute,datepipe: DatePipe) {
    this.datepip = datepipe;
   }
   options = [
    { value: '1', label: 'Actividades' },
    { value: '2', label: 'Fechas' },
    { value: '3', label: 'Sin filtro' },
  ];

  ngOnInit() {
    this._http.getAllReg("actividades").subscribe(
      result => {
       this.listActividades = result;
       this.listActividades = this.listActividades.Actividades;
      },
      error => {
        //this.utilidades.notificationWarning("Aviso","Error al descargar el informe","top-left");
      }
    );
  }
  generarInforme() {

    this._http.DownloadFileExcel("v1/generarInforme",{Data: {"ActividadId":this.act == '0' ? null : this.act,"FechaInicio":this.fechaInicio == null ? null : this.datepip.transform(this.fechaInicio, "yyyy-MM-dd"),"FechaFin":this.fechaFin == null ? null : this.datepip.transform(this.fechaFin, "yyyy-MM-dd")}}).subscribe(
      result => {
        this.resultadoRequest = result;
        const linkSource = 'data:'+'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'+';base64,' + this.resultadoRequest.Archivo;
        const downloadLink = document.createElement("a");
        const fileName = this.resultadoRequest.NombreArchivo;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      },
      error => {
        this.utilidades.notificationWarning("Aviso","Error al descargar el informe","top-left");
      }
    );
  }

  onChange(event){
    this.fechaInicio = null;
    this.fechaFin = null;
  }
  fechaChange(event){
    this.act = '0';
  }

  limpiarFiltros(){
    this.fechaInicio = null;
    this.fechaFin = null;
    this.act = '0';
  }
  

}
